Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-pdf-export', function (envelope) {

        var $context = envelope.message.data.context,
            $control = $('.x-product-details-pdf-export', $context);

        if ($control.length < 1) return;

        updateAttributes();

        function updateAttributes() {

            var $list = $('.js-attributes-list', $control);

            if ($list.length < 1) return;

            $('li.attribute', $list).each(function () {
                if ($(this).hasClass('ItemAttributes_IsTest') || $(this).hasClass('ItemAttributes_Gender') || $(this).hasClass('ItemAttributes_OverWeight') || $(this).hasClass('ItemAttributes_Latitude') || $(this).hasClass('ItemAttributes_Longitude') || $(this).hasClass('ItemAttributes_Address')) {
                    $(this).remove();
                }
            });

            if ($('li.attribute', $list).length < 1) {
                $('.product-attributes', $control).css('display', 'none');
            } 
        }

        function b64toBlob(b64Data, contentType, sliceSize) {
            contentType = contentType || '';
            sliceSize = sliceSize || 512;

            var byteCharacters = atob(b64Data);
            var byteArrays = [];

            for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                var slice = byteCharacters.slice(offset, offset + sliceSize);

                var byteNumbers = new Array(slice.length);
                for (var i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                var byteArray = new Uint8Array(byteNumbers);

                byteArrays.push(byteArray);
            }

            var blob = new Blob(byteArrays, { type: contentType });
            return blob;
        };

        $control.on('click', '.js-pdf-export-button', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            var options = {
                filenamehassuffixdatetime: false,
                filename: $('.pdf-filename', $control).text(),
                author: $('.pdf-author', $control).text(),
                title: $('.pdf-title', $control).text(),               
                subject: $('.pdf-subject', $control).text(),
                headerhtml: '<h1>' + $('.pdf-header', $control).html() + '</h1>',
                html: $('.pdf-body', $control).html(),
                footerhtml: '<h3>' + $('.pdf-footer', $control).html() + '</h3>',
                margin: {
                    top: 40,
                    bottom: 40,
                    left: 40,
                    right: 40
                }
                //security: {
                //    enable: false,
                //    ownerpassword: "",
                //    userpassword: "",
                //    canedit: true
                //},
            };

            Vendd.MessageBus.publishAsync($control.get(0), new Vendd.Product.Messages.PdfExport(options));
        });

        Vendd.MessageBus.subscribe(Vendd.Product.Messages.PdfExportSuccess, $control, function (envelope) {

            var pdf = {
                FileContents: envelope.message.data.FileContents,
                Filename: envelope.message.data.Filename
            };

            var blob = b64toBlob(pdf.FileContents, 'application/pdf');

            var a = document.createElement("a");
            a.style.visibility = 'hidden';
            document.body.appendChild(a);

            var fileURL = URL.createObjectURL(blob);
            a.href = fileURL;
            a.download = pdf.Filename;
            a.click();
            document.body.removeChild(a);
        });

    });

});

